/* ============================================
   DEAL CAMPAGNE BFE - TDTP
   ============================================

   Stuurt de tegeldeal-nudges aan vanuit één metaobject (deal_campaign):
   - [data-deal-bfe="pdp"]  productpagina: het Campaign counter-blok met
                            bron "Deal campaign" (campaign-counter-bfe)
   - [data-deal-bfe="bar"]  announcement bar: deal + klok      (deal-bar-bfe)
   - [data-deal-bfe="cart"] cart drawer: tegel-teller          (deal-cart-counter-bfe)
   - [data-deal-bfe="kicker"] hero-kicker met bron "Deal campaign" (section-hero)
   Plekken zonder eigen schakelaar in het metaobject (kicker) tonen zich
   altijd binnen het venster.

   De data komt uit snippets/deal-campaign-data-bfe.liquid (JSON-tag
   #deal-campaign-bfe-data): start/einde als epoch-ms, drempel, badge, link,
   producttypes die als tegel tellen, en per plek aan/uit.

   ZICHTBAARHEID: alle elementen worden met het hidden-attribuut uitgeleverd.
   Deze JS haalt dat er pas af als het NU binnen het venster valt, en zet het
   terug zodra het venster voorbij is. Een gecachete pagina toont dus nooit een
   verlopen actie (zelfde principe als campaign-counter-bfe.liquid).

   KORTING: alleen tonen/rekenen. De echte korting is de automatische korting
   in de Shopify-admin (Buy X Get Y, herhalend).

   CART: telt de hoeveelheid van regels waarvan product_type in de lijst staat.
   Cadeaus (_gift=true) tellen niet mee. Een tegel die door de korting €0 kost
   telt WEL mee, dus niet op prijs filteren. Ververst op elk
   theme:cart:change-event (Pipeline, cart-rewards, upsells, wizard).

   Eén boodschap overal: "Elke 3e tegel gratis" (locale headline). Geen
   "3 halen, 2 betalen · 6 halen, 4 betalen" meer: dubbele communicatie.

   Versie: 1.2 - 29-09-2026 — cart-teller loopt door na 6 (volgende gratis
           tegel), klok in de balk in blokjes, hero-kicker
   Versie: 1.1 - 29-09-2026 — headline i.p.v. twee stappen, klok in blokjes
           (campaign-counter-bfe), badge in de cart-teller
   Versie: 1.0 - 29-09-2026
   ============================================ */
(function () {
  'use strict';
  if (window.BFEDealCampaign) return;

  var dataEl = document.getElementById('deal-campaign-bfe-data');
  if (!dataEl) return;

  var cfg;
  try {
    cfg = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  if (!cfg || !cfg.campaigns || !cfg.campaigns.length) return;

  // Vangnet als het metaobject-veld leeg is: alle tegels (foto + standaard),
  // geen accessoires, DIY of B2B.
  var DEFAULT_TYPES = ['Delft Blue Tile', 'Personalised Tile', 'Delftify', 'limited edition'];

  // De t-filter escapet HTML-tekens; hier terug naar platte tekst.
  var decoder = document.createElement('textarea');
  function decode(str) {
    decoder.innerHTML = str || '';
    return decoder.value;
  }
  var i18n = {};
  Object.keys(cfg.i18n || {}).forEach(function (key) {
    i18n[key] = decode(cfg.i18n[key]);
  });

  function fill(template, values) {
    return String(template || '').replace(/\|\|(\w+)\|\|/g, function (match, key) {
      return values[key] !== undefined ? values[key] : match;
    });
  }

  function pad(value) {
    return value < 10 ? '0' + value : String(value);
  }

  // [dagen, uren, minuten, seconden] tot het einde
  function splitLeft(ms) {
    var left = Math.max(0, Math.floor(ms / 1000));
    return [Math.floor(left / 86400), Math.floor((left % 86400) / 3600), Math.floor((left % 3600) / 60), left % 60];
  }

  function currentCampaign(now) {
    for (var i = 0; i < cfg.campaigns.length; i++) {
      var c = cfg.campaigns[i];
      if (now >= c.start && now < c.end) return c;
    }
    return null;
  }

  function hasFutureCampaign(now) {
    for (var i = 0; i < cfg.campaigns.length; i++) {
      if (cfg.campaigns[i].end > now) return true;
    }
    return false;
  }

  function typesOf(campaign) {
    return campaign.types && campaign.types.length ? campaign.types : DEFAULT_TYPES;
  }

  // Link naar de eigen winkel: host eraf en het taal/markt-prefix van de
  // bezoeker ervoor (Shopify.routes.root, bv. /nl-nl/), zodat een NL-bezoeker
  // niet op de Engelse pagina landt. Externe links blijven ongewijzigd.
  function localUrl(raw) {
    try {
      var u = new URL(raw, window.location.origin);
      var own = u.hostname === window.location.hostname || /(^|\.)thedutchtileproject\.com$|\.myshopify\.com$/.test(u.hostname);
      if (!own) return raw;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var path = u.pathname;
      if (root !== '/' && path.indexOf(root) !== 0) path = root + path.replace(/^\//, '');
      return path + u.search + u.hash;
    } catch (e) {
      return raw;
    }
  }

  function setText(el, text) {
    if (el && el.textContent !== text) el.textContent = text;
  }

  function renderBadge(el, campaign) {
    var badge = el.querySelector('[data-deal-badge]');
    if (badge) {
      setText(badge, campaign.badge || '');
      badge.hidden = !campaign.badge;
    }
  }

  /* ---------- PDP + balk: badge, link, klok ---------- */
  function renderPromo(el, campaign, now) {
    renderBadge(el, campaign);

    var links = el.querySelectorAll('[data-deal-link]');
    for (var i = 0; i < links.length; i++) {
      if (campaign.url) {
        links[i].setAttribute('href', localUrl(campaign.url));
        links[i].hidden = false;
      } else {
        links[i].hidden = true;
      }
    }

    var parts = splitLeft(campaign.end - now);

    // Klok in blokjes (campaign-counter-bfe): dagen / uren / minuten / seconden
    var days = el.querySelector('[data-counter-days]');
    if (days) {
      setText(days, pad(parts[0]));
      setText(el.querySelector('[data-counter-hours]'), pad(parts[1]));
      setText(el.querySelector('[data-counter-minutes]'), pad(parts[2]));
      setText(el.querySelector('[data-counter-seconds]'), pad(parts[3]));
    }

    // Compacte klok in blokjes met een korte eenheid (balk): 04d 12u 39m 23s
    var clock = el.querySelector('[data-deal-clock]');
    if (clock) {
      var units = String(i18n.units_short || 'd|h|m|s').split('|');
      if (!clock.children.length) {
        for (var k = 0; k < 4; k++) {
          var box = document.createElement('span');
          box.className = 'deal-clock-bfe__box';
          box.innerHTML = '<span class="deal-clock-bfe__num"></span><span class="deal-clock-bfe__unit"></span>';
          box.lastChild.textContent = units[k] || '';
          clock.appendChild(box);
        }
      }
      for (var n = 0; n < 4; n++) setText(clock.children[n].firstChild, pad(parts[n]));
    }
  }

  /* ---------- Cart: tegel-teller ---------- */
  var lastCart = null;
  var cartRequested = false;

  function countTiles(cart, campaign) {
    if (!cart || !cart.items) return 0;
    var types = typesOf(campaign);
    var count = 0;
    cart.items.forEach(function (item) {
      if (item.properties && String(item.properties._gift) === 'true') return;
      if (types.indexOf(item.product_type) === -1) return;
      count += item.quantity;
    });
    return count;
  }

  // Tekst in twee delen: [behaald] · [volgende stap]. De deal herhaalt zich
  // (elke 3e tegel), dus er is altijd een volgende gratis tegel: ook bij 6 of 7
  // tegels geen "alles behaald", maar "✓ 2 tegels gratis · nog 2 voor de volgende".
  function cartMessage(count, t) {
    var free = Math.floor(count / t);
    var rem = t - (count % t);
    if (free === 0) {
      return { done: '', next: fill(rem === 1 ? i18n.cart_remaining_one : i18n.cart_remaining_other, { count: rem }) };
    }
    return {
      done: fill(free === 1 ? i18n.cart_free_one : i18n.cart_free_other, { count: free }),
      next: fill(i18n.cart_next, { count: rem })
    };
  }

  function renderCart(el, campaign) {
    if (!lastCart) {
      requestCart();
      return false;
    }
    var t = campaign.threshold;
    var count = countTiles(lastCart, campaign);
    if (count === 0) return false;

    renderBadge(el, campaign);
    var msg = cartMessage(count, t);
    var doneEl = el.querySelector('[data-deal-cart-done]');
    setText(doneEl, msg.done);
    if (doneEl) doneEl.hidden = !msg.done;
    var sep = el.querySelector('[data-deal-cart-sep]');
    if (sep) sep.hidden = !msg.done;
    setText(el.querySelector('[data-deal-cart-text]'), msg.next);

    // Vakjes: venster van 2 × drempel. Tot en met 5 tegels vakje 1-6; daarna
    // schuift het venster per groep van 3 op, zodat de volgende gratis tegel
    // altijd in beeld blijft (7 tegels = vakje 4-9, waarvan 4 gevuld).
    var slotsWrap = el.querySelector('[data-deal-cart-slots]');
    if (slotsWrap) {
      var total = 2 * t;
      var offset = Math.max(0, Math.floor(count / t) - 1) * t;
      if (slotsWrap.children.length !== total) {
        slotsWrap.innerHTML = '';
        for (var i = 1; i <= total; i++) {
          var slot = document.createElement('span');
          slot.className = 'deal-cart-bfe__slot' + (i % t === 0 ? ' deal-cart-bfe__slot--free' : '');
          if (i % t === 0) {
            var tag = document.createElement('span');
            tag.className = 'deal-cart-bfe__slot-tag';
            tag.textContent = i18n.free;
            slot.appendChild(tag);
          }
          slotsWrap.appendChild(slot);
        }
      }
      for (var j = 0; j < slotsWrap.children.length; j++) {
        slotsWrap.children[j].classList.toggle('is-filled', j < count - offset);
      }
    }
    return true;
  }

  function requestCart() {
    if (cartRequested) return;
    cartRequested = true;
    var root = (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart';
    fetch(root + '.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        lastCart = cart;
        render();
      })
      .catch(function () {});
  }

  /* ---------- Hoofdlus ---------- */
  var timer = null;

  function render() {
    var now = Date.now();
    var campaign = currentCampaign(now);
    var nodes = document.querySelectorAll('[data-deal-bfe]');

    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var place = el.getAttribute('data-deal-bfe');
      // Plek zonder eigen schakelaar in het metaobject: altijd binnen het venster
      var show = !!(campaign && (campaign[place] === undefined ? true : campaign[place]));

      // Alleen op tegels. Zonder data-product-type (bv. in de hero) geen check.
      if (show && place === 'pdp' && el.hasAttribute('data-product-type')) {
        show = typesOf(campaign).indexOf(el.getAttribute('data-product-type')) !== -1;
      }

      if (show) {
        show = place === 'cart' ? renderCart(el, campaign) : (renderPromo(el, campaign, now), true);
      }

      if (el.hidden === show) el.hidden = !show;
    }

    // Alles voorbij: klok stoppen. Nog een campagne op komst: blijven tikken,
    // zodat hij zonder herladen verschijnt.
    if (!hasFutureCampaign(now) && timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  document.addEventListener('theme:cart:change', function (event) {
    if (event.detail && event.detail.cart) {
      lastCart = event.detail.cart;
      render();
    }
  });

  // Na een reload kan Pipeline de drawer-DOM vervangen; opnieuw invullen.
  document.addEventListener('theme:cart:reload', function () {
    setTimeout(render, 400);
    setTimeout(render, 1200);
  });

  window.BFEDealCampaign = { render: render };

  render();
  timer = setInterval(render, 1000);
})();
